export enum GCPOnboardingHelp {
  Permissions,
  CheckPermissions,
  EnableGoogleAPIs,
  CreateServiceAccount,
  ServiceAccountEmailID,
  None,
}
